export enum enmTourOperatorConfirmationStatus {
    Yes,
    NotSent,
    No,
    Sent,
    Wait
}